import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '~/lib/api-client';
import { researchKeys } from '~/lib/query-keys';

/**
 * FRONT-1601: ask a running deep-research run to stop searching and write up
 * what it already has, rather than cutting it off outright. Marks the row
 * `finishRequestedAt` server-side; like cancel (`use-cancel-research.ts`),
 * this is COOPERATIVE, not immediate — the engine reads the flag back at its
 * next seam and moves on to synthesis from there, so the run doesn't finish
 * mid-step but does wrap up within roughly one stage. The banner reflects
 * the request (button flips to a disabled "Finishing…") once the
 * invalidation lands, ahead of the run underneath actually wrapping up.
 */
export function useFinishResearch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ runId }: { runId: number }) =>
      api.post(`/api/research/${runId}/finish`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: researchKeys.all });
    },
    onError: (err) => {
      toast.error(`Finish now failed: ${(err as Error).message}`);
    },
  });
}
